import { createRouter } from "@tanstack/react-router";

import { adminCommunicationRoute } from "@platform/features/admin/communications/communications.route";
import { adminTelemetryRoute } from "@platform/features/admin/telemetry/telemetry.route";
import { adminTenantsRoute } from "@platform/features/admin/tenants/tenants.route";
import { adminUsersRoute } from "@platform/features/admin/users/users.route";
import { testRoute } from "@platform/features/admin/test/test.route";
import { aiAppsRoute } from "@platform/features/ai-apps";
import { apiKeysRoute } from "@platform/features/api-keys/api-keys.route";
import { acceptInvitationRoute } from "@platform/features/auth/accept-invitation.route";
import { loginRoute } from "@platform/features/auth/login.route";
import { mcpConnectRoute } from "@platform/features/mcp-connect";
import { billingRoute } from "@platform/features/billing/billing.route";
import { homeRoute } from "@platform/features/home/home.route";
import { memoryRoute } from "@platform/features/memory/memory.route";
import { settingsRoute } from "@platform/features/settings/settings.route";
import { tenantRoute } from "@platform/features/tenant/tenant.route";
import { usageRoute } from "@platform/features/usage/usage.route";
import { webhookEndpointRoute, webhooksRoute } from "@platform/features/webhooks";
import { queryClient } from "@platform/core/query";
import { rootRoute } from "./root";
import { shellRoute } from "./shell.route";

const routeTree = rootRoute.addChildren([
	loginRoute,
	mcpConnectRoute,
	acceptInvitationRoute,
	shellRoute.addChildren([
		homeRoute,
		memoryRoute,
		apiKeysRoute,
		aiAppsRoute,
		webhooksRoute,
		webhookEndpointRoute,
		usageRoute,
		tenantRoute,
		billingRoute,
		settingsRoute,
		adminTelemetryRoute,
		adminUsersRoute,
		adminTenantsRoute,
		adminCommunicationRoute,
		testRoute,
	]),
]);

export const router = createRouter({
	routeTree,
	context: { queryClient },
});

// Registration gives <Link> and useParams app-wide type safety.
declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}
